/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/success': {
    width: 113,
    height: 130,
    viewBox: '0 0 113 130',
    data: '<g filter="url(#filter0_d)"><path pid="0" d="M10 65.993L44.648 108 102 4" _stroke="#24AB22" stroke-width="15"/></g><defs><filter id="filter0_d" x=".214" y=".378" width="112.353" height="128.909" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="4"/><feGaussianBlur stdDeviation="2"/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/><feBlend mode="multiply" in2="BackgroundImageFix" result="effect1_dropShadow"/><feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"/></filter></defs>'
  }
})
